import requests from "./httpService";

const WfhService = {
    getAll: (params) => {
        return requests.get(`/wfh-applications/all`, { params });
    },
    
    getDeptUsers: (params) => {
        return requests.get(`/wfh-applications/deptusers`, { params });
    },

    create: (data) => {
        return requests.post(`/wfh-applications/create`, data);
    },

    updateStatus: (id, data) => {
        return requests.post(`/wfh-applications/statusupdate/${id}`, data);
    },

    delete: (id, params) => {
        return requests.delete(`/wfh-applications/${id}`, { params });
    }
};

export default WfhService;
